var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screening-results-pills"},[_c('div',{staticClass:"header grey--text text--darken-2"},[_vm._v("Results")]),_c('count-pills',{attrs:{"counts":_vm.counts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }